<template>
    <div class="receipt-default">
        <div class="receipt-wrapper">
            <div v-if="htmlFromTextLines.length" class="printable-area" style="font-family: Arial, Helvetica, sans-serif;">
                <template v-for="(htmlLine, index) in htmlFromTextLines.slice(0, htmlFromTextLines.length - qrCodeEmbed)">
                    <div v-html="htmlLine"></div>
                </template>

                <div
                    v-if="this.options.isReceipt && order.generateQRCodeString()"
                    style="text-align: center; padding: 4px 0;"
                >
                    <qrcode
                        :value="order.generateQRCodeString()"
                        :options="{
                            errorCorrectionLevel: 'L',
                            margin: 0,
                            scale: 6,
                            quality: 1
                        }"
                        tag="img"
                        :style="`width: 100%; max-width: ${locale === 'me' ? '40' : '53'}mm; image-rendering: pixelated;`"
                    />
                </div>

                <template v-for="(htmlLine, index) in htmlFromTextLines.slice(htmlFromTextLines.length - qrCodeEmbed, htmlFromTextLines.length)">
                    <div v-html="htmlLine"></div>
                </template>

                <template v-for="(footerLine, index) in footerLines">
                    <div v-html="footerLine"></div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import HtmlGen from '@/wrappers/HtmlGen';

export default {
    props: {
        order: {
            type: Object,
            default: () => null
        },
        options: {
            type: Object,
            default: () => {}
        }
    },

    computed: {
        htmlFromTextLines() {
            const { isReceipt, isCopy, printingSector } = this.options
            const textLines = this.order.toTextLines({ isReceipt, isCopy, printingSector })
            return textLines.map(line => HtmlGen.fromTextLine(line))
        },

        footerLines() {
            const { isReceipt } = this.options
            if(!isReceipt) return [];

            const footerLines = ['[L]']
            let domain = ''

            if(isAllegra) domain = locale === 'sr' ? 'www.allegrapos.rs' : (locale === 'me' ? 'www.allegrapos.me' : 'www.allegrapos.ba')
            else domain = locale === 'sr' ? 'www.ariapos.rs' : (locale === 'me' ? 'www.ariapos.me' : 'www.ariapos.ba');
            footerLines.push('[C]' + domain)
            footerLines.push('[L]')

            return footerLines.map(line => HtmlGen.fromTextLine(line))
        },

        qrCodeEmbed() {
            return this.$printService.getQrCodeEmbed(this.order, this.htmlFromTextLines.join('\n'));
        }
    },
};
</script>

<style lang="scss" scoped>
.receipt-default {
    padding: 30px;
    min-height: 100%;
    display: flex;
    justify-content: center;
    background: #f0f1f7;
    font-family: Arial, Helvetica, sans-serif;
    -webkit-user-select: text;
    -webkit-app-region: none;

    .receipt-wrapper {
        padding: 20px 30px;
        max-width: 470px;
        width: 100%;
        background: white;
        box-shadow: 0 3px 5px rgba(0,0,0,0.10);
        font-size: 16px;
    }
}
</style>
